makeErrorEnum = require 'lib/make-error-enum'

module.exports = makeErrorEnum 'CreditCardForm', [
  'InvalidField'
  'PostError'
  'PollError'
]



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/credit-card-form-error.coffee